/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
// #region import
import React, { useEffect, useState } from 'react';
import GetMunicipality from '../../../api/MunicipalityAPI';
import { SendRequestDto } from '../../../api/PushSendAPI';
import {
  defaultChehckedCity,
  Municipality,
  MunicipalityCode,
} from '../../../models/municipality';
import {
  DEVICE_TYPE_ANDROID_CODE,
  DEVICE_TYPE_IOS_CODE,
  ERROR_MESSAGE_API,
  PUSH_INPUT_FORM_TEXT,
} from '../../../util/Const';
import getBytes from '../../../util/StringUtil';
import {
  Title,
  Message,
  CurrentLocation,
  Url,
  NotificationType,
} from './FormItem';
// #endregion import

/**
 * 通知送信画面
 * @param history
 */
const NotificationSendingForm = (props: any) => {
  const { history, input, setInput, setIsInput } = props;

  // #region useState
  const [municipality, setMunicipality] = useState<Municipality[]>([]);
  const [title, setTitle] = useState<string>((): string => {
    if (input === undefined) {
      return '';
    }
    return input.title;
  });
  const [message, setMessage] = useState<string>((): string => {
    if (input === undefined) {
      return '';
    }
    return input.message;
  });
  const [currentLocation, setCurrentLocation] = useState<MunicipalityCode[]>(
    (): MunicipalityCode[] => {
      if (input === undefined) {
        return defaultChehckedCity();
      }
      return input.target;
    }
  );
  const [url, setUrl] = useState<string>((): string => {
    if (input === undefined || input.url === undefined) {
      return '';
    }
    return input.url;
  });
  const [type, setType] = useState<Number>((): Number => {
    if (input !== undefined) {
      return input.type;
    }
    if (sessionStorage.getItem('city') === '0') {
      if (sessionStorage.getItem('village') === '0') {
        return 5;
      }
      if (sessionStorage.getItem('village') === '1') {
        return 2;
      }
      if (sessionStorage.getItem('village') === '2') {
        return 3;
      }
    }
    return 1;
  });
  // #endregion useState

  useEffect(() => {
    GetMunicipality()
      .then((response) => {
        setMunicipality(response);
      })
      .catch(() => {
        alert(ERROR_MESSAGE_API);
      });
  }, []);

  if (!history) {
    return null;
  }

  const onClickSendBtn = async () => {
    try {
      // タイトル
      if (title.length <= 0) {
        alert('タイトルを入力してください。');
        return;
      }
      if (getBytes(title) > 256) {
        alert('タイトルの文字数が多すぎます。');
        return;
      }
      // メッセージ
      if (message.length <= 0) {
        alert('メッセージを入力してください。');
        return;
      }
      if (getBytes(message) > 1024) {
        alert('メッセージの文字数が多すぎます。');
        return;
      }
      if (getBytes(url) > 2048) {
        alert('URLが長すぎます。');
        return;
      }
      // const isDebug = sessionStorage.getItem('name') === 'rcsc' ? 1 : 0;
      const request: SendRequestDto = {
        title,
        message,
        author: sessionStorage.getItem('name'),
        device: [DEVICE_TYPE_ANDROID_CODE, DEVICE_TYPE_IOS_CODE],
        target: currentLocation,
        url,
        type,
        is_debug: 0,
      };
      setInput(request);
      setIsInput(false);
    } catch (error) {
      alert(ERROR_MESSAGE_API);
    }
  };

  // #region return
  return (
    <article id="sending_form" className="notification_sending">
      <h1>{PUSH_INPUT_FORM_TEXT}</h1>
      <div>
        <dl>
          <Title title={title} setTitle={setTitle} />
          <Message message={message} setMessage={setMessage} />
          <CurrentLocation
            municipality={municipality}
            currentLocation={currentLocation}
            setCurrentLocation={setCurrentLocation}
          />
          <Url url={url} setUrl={setUrl} />
          <NotificationType type={type} setType={setType} />
        </dl>
        <button type="button" className="btn" onClick={onClickSendBtn}>
          確認
        </button>
      </div>
    </article>
  );
  // #endregion return
};
export default NotificationSendingForm;
